import { useMutation, useQuery, useQueryClient } from 'react-query';
import * as api from '../../services/api';
import useAccount from '../account/useAccount';

const useOSEmployee = ({
  employeeId,
  enabled = true,
  contextProjectId = undefined,
  contextShiftId = undefined
} = {}) => {
  const { accountId } = useAccount();
  const queryClient = useQueryClient();

  const storeKey = ['employee', accountId, employeeId];
  const { isLoading, data, refetch } = useQuery(
    storeKey,
    () => api.fetchOSEmployee({ accountId, employeeId, contextProjectId, contextShiftId }),
    {
      staleTime: 0,
      cacheTime: 0,
      enabled: enabled && !!employeeId
    }
  );

  const { mutateAsync: updateEmployee } = useMutation(
    (values) => api.updateOSEmployee({ accountId, employeeId, ...values }),
    {
      throwOnError: true,
      onSuccess: () => {
        queryClient.invalidateQueries(storeKey, { exact: true });
        queryClient.invalidateQueries(['OSProjectInfo', accountId]); // make sure to re-calculate statistics
      }
    }
  );

  return {
    isLoading: isLoading && employeeId,
    data: data?.data,
    updateEmployee,
    refetch
  };
};

export default useOSEmployee;
